import PropTypes from "prop-types";
import React from "react";
import { Anchor } from "@mantine/core";
import { useStylesButton } from "../../utils/mantine/useStylesButton";
import {
  IconChevronLeft,
  IconChevronRight,
  IconDownload,
} from "@tabler/icons-react";
import LogoVBSvg from "../../svg/LogoVBSvg";
import LogoPDFSvg from "../../svg/LogoPDFSvg";
import LogoBlockchainSvg from "../../svg/LogoBlockchainSvg";

const CustomAnchor = ({
  text,
  title = "",
  target = "_self",
  componentClasses,
  href = "#",
  underline = "never",
  IconChevronLeftEnable = false,
  IconChevronRightEnable = false,
  IconChevronRightLandingEnable = false,
  IconDownloadFile = false,
  LogoVBSvgEnable = false,
  LogoBlockchainSvgEnable = false,
  LogoPDFSvgEnable = false,
  color = "",
  onClick = undefined,
  download = false,
}) => {
  const { classes } = useStylesButton();
  const classList = componentClasses.split(" ");

  const combinedClasses = classList
    .map((className) => {
      return classes[className] || className;
    })
    .filter(Boolean);
  return (
    <Anchor
      href={href}
      title={title}
      target={target}
      {...(color ? { c: color } : {})}
      underline={underline}
      className={combinedClasses.join(" ")}
      onClick={onClick || (() => {})}
      download={download}
    >
      {IconChevronLeftEnable ? (
        <IconChevronLeft className={classes.iconChevronLeft} />
      ) : (
        ""
      )}
      {IconDownloadFile && <IconDownload />}
      {text}
      {IconChevronRightEnable && (
        <IconChevronRight className={classes.iconChevronLeft} />
      )}
      {IconChevronRightLandingEnable && <IconChevronRight />}

      {LogoVBSvgEnable && <LogoVBSvg />}
      {LogoPDFSvgEnable && <LogoPDFSvg />}
      {LogoBlockchainSvgEnable && <LogoBlockchainSvg />}
    </Anchor>
  );
};

CustomAnchor.propTypes = {
  text: PropTypes.string.isRequired,
  title: PropTypes.string,
  componentClasses: PropTypes.string,
  target: PropTypes.string,
  color: PropTypes.string,
  href: PropTypes.string.isRequired,
  underline: PropTypes.bool,
  IconChevronLeftEnable: PropTypes.bool,
  IconChevronRightEnable: PropTypes.bool,
  IconChevronRightLandingEnable: PropTypes.bool,
  IconDownloadFile: PropTypes.bool,
  LogoVBSvgEnable: PropTypes.bool,
  LogoBlockchainSvgEnable: PropTypes.bool,
  LogoPDFSvgEnable: PropTypes.bool,
  download: PropTypes.bool,
  onClick: PropTypes.func,
};

export default CustomAnchor;
